module.exports = __webpack_public_path__ + "static/media/1920.56f282f3.jpg";